import DiagnosisPage from "./DiagnosisPage";

export default DiagnosisPage;